/**
 * @generated SignedSource<<7e1f30ea88dff3a4a4d22c28086f530b>>
 * @relayHash faac0047c8800a35bde340f8d84f7d60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 17407acccd724e47d0c5038fe8062d3b2fd61bb307e3fd1b69b359acb985d6d8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessSharedCalendarQuery } from './src_jiraBusinessSharedCalendarQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessSharedCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "17407acccd724e47d0c5038fe8062d3b2fd61bb307e3fd1b69b359acb985d6d8",
    "metadata": {},
    "name": "src_jiraBusinessSharedCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
